import React from 'react';
import { 
  Zap, 
  Dumbbell, 
  ShieldCheck, 
  Activity, 
  Smile, 
  TrendingUp, 
  Brain, 
  Calendar,
  UserCheck
} from 'lucide-react';

export default function FunFact({ data, colorVariant }) {
  const keyBenefits = [
    { 
      text: 'Enhanced Daily Wellness', 
      desc: 'Boost your natural energy levels throughout the day', 
      icon: <Zap size={32} />, 
      color: '#FF9500' // Orange
    },
    { 
      text: 'Maintains Daily Balance', 
      desc: 'Support your active lifestyle and everyday energy levels', 
      icon: <Dumbbell size={32} />, 
      color: '#FF3B30' // Red
    },
    { 
      text: 'Natural Daily Support', 
      desc: 'Increased vigor and wellness for your active routine', 
      icon: <TrendingUp size={32} />, 
      color: '#34C759' // Green
    },
    { 
      text: 'General Wellness Support', 
      desc: 'Naturally support your body\'s daily needs', 
      icon: <ShieldCheck size={32} />, 
      color: '#007AFF' // Blue
    },
    { 
      text: 'Promotes Daily Balance', 
      desc: 'Supports general wellbeing and healthy lifestyle', 
      icon: <Activity size={32} />, 
      color: '#5AC8FA' // Teal
    },
    { 
      text: 'Promotes Overall Wellbeing', 
      desc: 'Better energy levels lead to a more active and happy life', 
      icon: <Smile size={32} />, 
      color: '#AF52DE' // Purple
    },
    // { 
    //   text: 'Builds Higher Confidence', 
    //   desc: 'Feel more assured and self-confident in your daily tasks', 
    //   icon: <UserCheck size={32} />, 
    //   color: '#5856D6' // Indigo
    // },
    // { 
    //   text: 'Reduces Mental Fatigue', 
    //   desc: 'Combat daily stress with improved mental clarity and focus', 
    //   icon: <Brain size={32} />, 
    //   color: '#FF2D55' // Pink
    // },
    // { 
    //   text: 'Visible results in 30 days', 
    //   desc: 'Notice improvements in just one month of regular use', 
    //   icon: <Calendar size={32} />, 
    //   color: '#FFCC00' // Yellow
    // }
  ];

  return (
    <div className="text-center">
      <h2 className="cs_fs_48 cs_bold mb-5" style={{color: 'white'}}>Key Benefits</h2>
      <div className="row">
        {keyBenefits.map((benefit, index) => {
          return (
            <div className="col-lg-4 col-md-6 mb-4" key={index}>
              <div 
                className="cs_benefit_card text-center" 
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  backdropFilter: 'blur(10px)',
                  WebkitBackdropFilter: 'blur(10px)',
                  padding: '40px 30px',
                  borderRadius: '20px',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  cursor: 'default'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.08)';
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.2)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                }}
              >
                <div className="mb-4 d-flex justify-content-center align-items-center" style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '24px',
                  background: `linear-gradient(135deg, ${benefit.color}22, ${benefit.color}44)`,
                  color: benefit.color,
                  boxShadow: `0 10px 20px ${benefit.color}22`,
                  border: `1px solid ${benefit.color}33`
                }}>
                  {benefit.icon}
                </div>
                <h3 className="mb-3" style={{
                  color: 'white', 
                  fontSize: '20px', 
                  fontWeight: '700',
                  letterSpacing: '-0.02em'
                }}>
                  {benefit.text}
                </h3>
                <p className="mb-0" style={{
                  color: 'rgba(255, 255, 255, 0.6)', 
                  fontSize: '15px', 
                  lineHeight: '1.6',
                  maxWidth: '240px'
                }}>
                  {benefit.desc}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
